import type { AppRouteBeforeServerRenderContext } from 'src/shared/routes';

import { getIsCommunityPetition } from 'src/app/shared/api/petitions';

export const handleAdvocatesRedirect = async ({
	params: { slug: slugOrId },
	utilities,
	redirect,
	getSessionUtilities,
}: AppRouteBeforeServerRenderContext): Promise<void> => {
	const isCommunityPetition = await getIsCommunityPetition(slugOrId, utilities);

	const session = await getSessionUtilities();

	const { environment } = session;

	const isProduction = environment.getEnvironment() === 'production';

	if (!isCommunityPetition && isProduction) {
		redirect(`/p/${slugOrId}`);
	}
};
